<div class="root">
  <div class="container">
    <h1 class="title">{{ 'skyproRoutingPage.error' | transloco | skyUiTypograf }}</h1>
    <p class="description">
      {{ 'skyproRoutingPage.siteSleep' | transloco | skyUiTypograf }}
      <br />
      {{ 'skyproRoutingPage.tryRelogin' | transloco | skyUiTypograf }}
    </p>
    <div class="actions">
      <ds-button class="action" type="primary-blue" size="m" (click)="logout()">
        {{ 'skyproRoutingPage.logout' | transloco | skyUiTypograf }}
      </ds-button>

      <a class="action link" href="/student-cabinet">
        {{ 'skyproRoutingPage.goToMain' | transloco | skyUiTypograf }}
      </a>
    </div>
  </div>
</div>
